import './ReceptionHeader.css';

export const ReceptionHeader = ({ onExit, name }) => {
  return (
    <div className="reception-header">
      <div className="user-decoration col-8"><span>{name}</span></div>
      <button className="logoff-btn" onClick={onExit}>Вихід</button>
    </div>
  )
};